import { FormSection } from '@/containers/forms/FormSection'
import { VehicleForm } from './VehicleForm'

export const Vehicle = ({ number = 1 }: { number?: number }) => {
  return (
    <FormSection number={number} sectionTitle="Vozidlo">
      <VehicleForm />
    </FormSection>
  )
}